/* eslint-disable i18next/no-literal-string -- styling, not user-visible */
import { defineSlotRecipe } from '@chakra-ui/react';

export const select = defineSlotRecipe({
  className: 'chakra-select',
  slots: [
    'root',
    'trigger',
    'indicatorGroup',
    'indicator',
    'content',
    'item',
    'control',
    'itemText',
    'itemGroup',
    'itemGroupLabel',
    'label',
    'valueText',
    'clearTrigger',
  ],

  variants: {
    size: {
      sm: {
        root: {
          '--select-trigger-height': 'sizes.10',
          '--select-trigger-padding-x': 'spacing.2.5',
        },
      },
    },
  },
});
